"use strict";

/**
 *
 * Counts the characters of a text input and shows it at the specified target.
 *
 */

/**
 *
 * Counts the characters of an input and updates the target.
 *
 * @param {object} sourceElement the source element reference to DOM.
 * @param {object} targetElement the target element reference to DOM.
 * @param {number} maximum the maximum number of characters.
 *
 */
function countCharacters(sourceElement, targetElement, maximum, timeout) {
  const lengthOfText = $(sourceElement).val().length;
  const charsLeft = maximum - lengthOfText;
  $(targetElement).text(charsLeft);
  window.clearTimeout(timeout);
}

/**
 *
 * initializes the component
 *
 */
function onLoad() {
  $(".js-char-count").each(function(i, item) {
    const sourceQuery = $(item).attr("data-source-query");
    const sourceEventQuery = $(item).attr("data-event-query");
    const sourceElement = $(item).find(sourceQuery);
    const sourceEventElement = $(item).find(sourceEventQuery);
    const targetElement = $(item).find(".js-char-count-target");
    const maximum = $(item).attr("data-max-chars");

    countCharacters(sourceElement, targetElement, maximum);
    $(sourceEventElement).on("change input paste keydown", function() {
      countCharacters(sourceElement, targetElement, maximum);
      let timeout;
      timeout = window.setTimeout(function() {
        countCharacters(sourceElement, targetElement, maximum, timeout);
      }, 10);
    });
  });
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-chars-counter/booking-chars-counter.js